var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g, _path22, _path23, _path24, _path25, _path26, _g2, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _g3, _path46, _path47, _path48, _path49, _path50, _path51;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNoFilters = function SvgNoFilters(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 289,
    height: 242,
    viewBox: "0 0 289 242",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes slideInUpQuestionMark{0%{transform:translateY(45%);visibility:visible}to{transform:translateY(0)}}.slideInUpQuestionMark{-webkit-animation-name:slideInUpQuestionMark;animation-name:slideInUpQuestionMark;-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-fill-mode:both;animation-fill-mode:both}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M205.7 229.1c98.7-13.4 77.4-142.5 35.8-136C199.9 99.6 181 63 155 31.5c-58-70-143.5 40-139.3 98.8 0 0-7.7 92.5 83.8 95.4l106.1 3.4Z",
    fill: "#E8F2FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "slideInUpQuestionMark",
    d: "M163.4 133.3a46.7 46.7 0 1 0 .2-93.3 46.7 46.7 0 0 0-.2 93.3Z",
    fill: "#05387D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "slideInUpQuestionMark",
    d: "M178.2 71.3c.1 2.4-.4 4.8-1.5 7l-.5.7a15 15 0 0 1-1.3 1.8l-1 1-.6.4-.1.1-1.6 1.2c-2 1.3-3.2 2.3-3.4 3v1.4c.2 1.7 0 3-.6 3.7-.5.7-1.3 1.2-2.2 1.5-.9.4-1.8.6-2.7.6h-.1c-2.2 0-3.8-.8-5-2.1-.8-1-1-2.2-.9-3.5l.2-1.5c.2-1.4.3-2.4.5-2.9.2-.9.6-1.8 1.4-2.6a15.1 15.1 0 0 1 4.3-3.7l2.3-1.5c.4-.4 1-.9 1.4-1.6.5-.6.7-1.3.7-2 0-1.2-.5-2.2-1.4-3a6.4 6.4 0 0 0-3.2-1.4c-1.5-.2-2.5 0-3.2.4-.4.3-.8 1-1.3 2.2l-.6 1.5c-.1.4-.4.9-.9 1.4-.4.5-.9.9-1.5 1.2-1.2.6-2.7.7-4.6.2-.8-.2-1.6-.5-2.3-1a5 5 0 0 1-1.8-1.4v-.2c-1.4-1.9-.9-4.4 1.5-7.3l.4-.5.6-.5.1-.2c1.8-1.7 3.9-3 6.3-4s5-1.4 7.6-1.4h1l2.7.4.8.2h.2a14.3 14.3 0 0 1 8.6 6.4 13 13 0 0 1 1.7 6Zm-9.8 31.5.1 1.2-.1.8v.2h-.1c-.2 1.3-1.1 2.4-2.7 3.1l-.3.2c-.8.4-1.8.6-2.8.6a5 5 0 0 1-3-1c-1.2-.9-2-1.9-2.4-3a6 6 0 0 1-.2-3.8c.3-1.2.9-2.2 1.7-2.9.8-.7 1.8-1 2.9-1 .6 0 1.2 0 1.7.2h.2v.1h.1l.6.3c1 .5 2 1.2 2.8 2 .7 1 1.2 2 1.5 3Z",
    fill: "#F9E333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M173.4 227.2h-91c-2 0-3.6-1.6-3.6-3.6v-95.1h94.6v98.7Z",
    fill: "#86C7EE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M217.1 227.2H168v-98.7h52.8v95.1c0 2-1.6 3.6-3.6 3.6Z",
    fill: "#86C7EE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M132.3 128.5h-15.8v53.8h15.8v-53.8ZM132.3 200.9h-15.8v26.3h15.8v-26.3Z",
    fill: "#5CB1E0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M161.5 137.5h-20.8a.5.5 0 0 1-.5-.5v-2.3c0-.3.2-.5.5-.5h20.8c.3 0 .6.2.6.5v2.3c0 .3-.3.5-.6.5ZM154.8 142h-14.2a.4.4 0 0 1-.4-.4v-2.4c0-.3.2-.5.4-.5h14.2c.2 0 .4.2.4.5v2.4c0 .2-.2.4-.4.4Z",
    fill: "#197BBF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M147.6 105.7H58.5l20.3 22.8h89l-20.2-22.8Z",
    fill: "#86C7EE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M147.6 105.7H58.5l20.3 22.8h89l-20.2-22.8Z",
    fill: "#74BAE8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M132.3 128.5h-15.8L100 105.7h15.8l16.6 22.8Z",
    fill: "#5CB1E0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M188.2 105.7H241l-20.3 22.8h-52.8l20.3-22.8Z",
    fill: "#86C7EE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M217.1 227.2H168v-98.7h52.8v95.1c0 2-1.6 3.6-3.6 3.6Z",
    fill: "#74BAE8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8 169.4h170",
    stroke: "#B1E9ED",
    strokeWidth: 10.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9 176.7a7.2 7.2 0 1 0 0-14.5 7.2 7.2 0 0 0 0 14.5ZM206.7 176.7a7.2 7.2 0 1 0 0-14.5 7.2 7.2 0 0 0 0 14.5Z",
    fill: "#fff",
    stroke: "#197BBF",
    strokeWidth: 10.4,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M104.2 169.4h95.2",
    stroke: "#197BBF",
    strokeWidth: 10.4,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M231.3 159.4c-1 6.5-15.4 10-15.4 10s-1 .8.4 1.2c4.5 1 16 2 21.4-5.4 7.1-9.8-6.4-5.8-6.4-5.8ZM275.2 193.5s1.3 1.8 1.5 2.5l1.2-.5-1.7-3.8-1 1.8Z",
    fill: "#05387D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m275.4 193.7 1.7 3.2 3.5-1.4s-1.1-1.3-2.9-.3l-2.3-1.5ZM265.4 196.3s2.2 1 3 1.2l-.5 1.3-4.2-1.3 1.7-1.2Z",
    fill: "#05387D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m265.7 196.4 3.6 1.4-.9 2-1.4.8s-1-1 .5-2l-1.8-2.2Z",
    fill: "#05387D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m247.7 176.5 12.7-7.6s9.4 8.2 17 24c.2.3 0 .7-.2.8l-1.3.7c-.3.1-.5 0-.7-.1a95 95 0 0 0-13-13.3.8.8 0 0 0-.8-.2l-3 1.2-.8.4c-.3.1-.5.4-.5.7 0 2 .3 4.4 1 6 1 2.5 3 5.4 8.6 7.3.3.2.4.5.2.8l-.7 1c-.2.2-.5.3-.7.2 0 0-5.6-.8-11.4-5.8a32.4 32.4 0 0 1-5.1-15l-1.3-1.1Z",
    fill: "#373848"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m237.7 165.2-7.3-3.6s1.6-3 2.5-8.4c.5-3.5 3.1-5.1 4.4 1.3 1 5.4.4 10.7.4 10.7Z",
    fill: "#007ECC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M235 150.5c-4.2 11.5 7 18.4 12.7 28.4.3.5 1 .5 1.6.3l14.6-6.4c.6-.3 1-1 .8-1.6-.5-2.2-3.3-4.3-3.8-7.5-2.1-14-8.4-20.7-10-21l-2.6.6c-2.7.8-12.2 4-13.4 7.2Z",
    fill: "#CCE9FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M233 152.1a81.1 81.1 0 0 1 15.3-7c.7-.3 1.2.8.4 1a81.3 81.3 0 0 0-15 7c-.7.5-1.4-.5-.7-1ZM233.7 154.6c5.3-2.9 10.9-5.3 16.6-7.3.7-.3 1.1.9.4 1.1-5.7 2.1-11.2 4.5-16.6 7.3-.3.2-.7 0-.8-.3-.2-.4 0-.7.4-.8ZM233.6 157.4l4.6-2 4.4-2.3a40.3 40.3 0 0 1 11.6-3.7c.8 0 .9 1.2 0 1.2-2 .3-4.3.8-6.2 1.6l-4.5 1.9-4.3 2.2-5.1 2.3c-.8.3-1.2-.8-.5-1.2ZM234.3 160.4l9.9-4.6c1.6-.7 3.2-1.5 4.9-2 1.3-.5 2.6-.8 4-1.2 1.6-.5 3.3-1 5-1.7.8-.3 1.2.9.5 1.2-2.8 1-5.6 1.8-8.5 2.6-3.4 1-6.5 2.8-9.7 4.3l-5.7 2.6c-.7.4-1.1-.8-.4-1.2ZM236 163a109.2 109.2 0 0 1 17.6-7.3l1.6-.3c1.4-.3 3-.8 4-1.8.7-.5 1.4.5.8 1-1 .9-2.4 1.4-3.7 1.8-1.3.4-2.7.5-4 1a108.7 108.7 0 0 0-16 6.7c-.2.2-.6 0-.7-.3-.2-.4 0-.7.3-.8ZM237.3 165.2c3.3-1.7 6.7-3 10.2-4.3l4.9-2.1a24.8 24.8 0 0 1 3.7-1.2l.6-.1s.5-.1.4 0c1-.3 2.3-.8 3-1.8.4-.6 1.4.2 1 .8-.7 1-2 1.6-3.1 2l-1.5.3-2.7.8-5 2c-1.7.8-3.5 1.4-5.3 2.1l-5.8 2.6c-.3.2-.7 0-.8-.3-.1-.4 0-.6.4-.8ZM238.7 167c3.2-1.6 6.7-2.8 10-4 1.8-.6 3.5-1.1 5.2-1.8l4.5-1.9c1-.4 2.2-.9 2.8-1.8.2-.3.7-.3.9 0 .3.1.3.5 0 .8-.6 1-1.8 1.5-2.8 2l-4 1.7-10.4 3.7a53 53 0 0 0-5.8 2.4c-.7.4-1.1-.8-.4-1.1ZM240 168.8a248 248 0 0 0 12.9-4.5c2.3-.9 4.7-1.9 7-3l.2-.2c.1 0 .2 0 .3-.2l.6-.3 1.1-.7c.7-.4 1.4.6.8 1-1.6 1-3.3 2-5 2.7-3 1.4-6.2 2.5-9.3 3.6l-8 2.7c-.8.3-1.3-.9-.5-1.1ZM241.3 170.6c2.8-1 5.7-1.8 8.6-2.7 2.8-.8 5.6-1.5 8.2-2.7a59 59 0 0 0 4.5-2.4c.7-.4 1.4.6.7 1-2.5 1.5-5.1 3-7.9 3.8-2.9 1-5.8 1.7-8.7 2.6l-5 1.6c-.7.2-1.2-1-.4-1.2Z",
    fill: "#87C8EF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M242 172.6c1.3-.7 2.8-1 4.2-1.2 1.5-.3 3-.6 4.4-1.1l4.3-1.6 4.2-1.5c1.6-.7 3-1.5 4.4-2.5.6-.5 1.3.5.7 1a25 25 0 0 1-3.9 2.3l-4.2 1.6c-3 1-5.8 2.3-8.8 2.9-1.7.3-3.3.5-4.9 1.2-.7.4-1.1-.8-.4-1.1ZM243.7 174.6a16 16 0 0 1 3.8-1.1c1.4-.3 2.8-.5 4.2-1 2.7-.9 5.4-1.9 8-3.2 1.4-.7 2.7-1.5 4-2.5.6-.5 1.3.5.7 1a45 45 0 0 1-16 6.7c-1.4.4-2.9.6-4.3 1.2-.7.4-1.1-.8-.4-1.1Z",
    fill: "#87C8EF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M245.6 177c5.6-1.9 11.4-3.6 16.8-6.1 1-.5 2.4-1.2 2.6-2.4.2-.8 1.5-.6 1.3.2-.3 1.2-1.2 2.1-2.3 2.7-1.2.8-2.6 1.3-4 1.9a120 120 0 0 1-8.8 3.2l-5.2 1.7c-.7.2-1.2-1-.4-1.2Z",
    fill: "#87C8EF"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M242.7 148.5c1-.3 2-2.6 2-4.1l-1.3-1.9c-.3-.6-.8-1.2-1.1-2l-3.5 3.2s1 1.2 1.6 2.3l.2.3c.2.5 1 2.4 2 2.2Z",
    fill: "#05387D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M243 135.3c.4 1.6-.5 6.4-1.7 7.4-1.7 1.5-4.5 1.6-5.8-.4-1.2-2 .1-8.2 1.4-9.1 2-1.4 5.4-.3 6 2.1Z",
    fill: "#05387D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M236.2 133c2.8-.8 4.7-2.9 6.5 1 .2.2.5 0 .8.2.8.5.7 1.5.6 2.3a8.5 8.5 0 0 1-1.2 3.2c-.2.3-.4.5-.7.6-.5.3-.6-1.6-.6-2.6 0-.8-1-1.2-1.5-.5v-.7s.4-3-4.3-1.1c-1.8.7-1.2-3-.5-3.4 0 0 0 1.2.9 1Z",
    fill: "#82CAF8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m258.5 153.5.3-7.1c8.4 1.5 3.4-9 3.4-9l1-1.2s11 15.6-4.7 17.3Z",
    fill: "#05387D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m258.6 153.3.2-7s-4.6-2.7-7.3-3.2c-2.6-.5-4.3 4.3.1 8.3 2.6 2.2 7 1.9 7 1.9Z",
    fill: "#CCE9FF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M251.8 142.9a9 9 0 0 0-.8 7.7c.2.6-.7 1-1 .3-.9-3-.5-6.3 1.1-8.8.4-.5 1 .2.7.8Z",
    fill: "#87C8EF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M253.7 143.5c-.2.9-.6 1.6-1 2.4l-.5 2.4c-.1 1.5.1 3 1 4.2.3.5-.3 1.3-.7.7a7.2 7.2 0 0 1-1.2-4.5c0-1 .2-1.8.5-2.7l.4-1.3c.2-.4.5-.9.6-1.4.1-.7 1-.4.9.2Z",
    fill: "#87C8EF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "m255.4 144-.8 2.4a9 9 0 0 0-.6 2.7c0 1.5.4 3 1.4 4 .4.5-.2 1.3-.6.9a6.6 6.6 0 0 1-1.7-4.6c0-1 .2-1.9.5-2.8l.4-1.4.5-1.4c0-.6 1-.4.9.2Z",
    fill: "#87C8EF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M256.8 145c-.3 1.5-.8 3-.8 4.6-.1 1.6.5 3 1.3 4.3.3.6-.5 1.2-.8.6-.8-1.5-1.5-3-1.4-4.7 0-1.8.5-3.4.9-5 .1-.7 1-.5.8.2Z",
    fill: "#87C8EF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M258.3 145a20.4 20.4 0 0 0-.1 8.5c.1.7-.7 1-.9.3a23.1 23.1 0 0 1 0-9.1c.2-.6 1.1-.4 1 .3Z",
    fill: "#87C8EF"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m254.4 152.6-2.2-1.3c-.8-.4-1.4-.8-2-1.4l-.5-.4-.3-.6c-.2-.4-.4-.8-.4-1.2-.2-1-.2-1.9.2-2.8a5 5 0 0 0-.2 4.3c.1.4.4.8.7 1.2.5.8 1.3 1.3 2.2 1.6a9 9 0 0 0 2.5.6ZM236.2 158.5l4.3-2 1.4 3.9-1.5 2.4-2.5-.6-1.7-3.7Z",
    fill: "#82CAF8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m240.5 156.5.5 2 .7 2v-.2l-.7 1.2-.6 1.3a16.9 16.9 0 0 0 1.7-2.3v-.2l-.7-2-.9-1.8Z",
    fill: "#007ECC"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M213.3 168.8h1.6s-.3-.9 0-1c.4-.1 1.9 1.4 1.9 1.4l-.5 1.3-2.5.4-.4-.3-.5-1.3c-.1-.2 0-.5.4-.5Z",
    fill: "#05387D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M261.9 17.7v148.7",
    stroke: "#007ECC",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m241.3 171.9.7-1 2.5 3.4-3.2-2.4Z",
    fill: "#05387D"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M241.3 171.9s17.8-4.4 20-8.5l1.2 3s-6.9 6-19 8l-2.2-2.5Z",
    fill: "#007ECC"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m246.7 172.3-.2.1c-.2 0-.4 0-.5-.2l-.7-1.4c0-.2 0-.5.2-.6h.1c.2-.1.5 0 .6.1l.7 1.5c.1.2 0 .4-.2.5ZM253.6 169.9h-.2c-.2.2-.4.1-.5 0l-.7-1.6c-.1-.2 0-.4.1-.5h.2c.2-.1.4 0 .5.1l.8 1.5c0 .2 0 .4-.2.5ZM263.1 136.2l.5-1.8v-.3l-.7-.6h-.3l-.7.3c-.1 0-.2.1-.2.3l-.4 1.2-.8.1c0 .4 1.6 1.5 1.6 1.5l1-.7Z",
    fill: "#05387D"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m262.7 134.5-.7-.8.6.9ZM263 134.4l-.7-.9.6 1 .1-.1ZM263.3 134.3l-.7-1v.2l.6.8h.1ZM262 136.8l.5.8.6-1.4-1 .7ZM71 226l1.3 2.2c0 .2.3.3.5.2.4 0 .2.2.6-.1.1-.1.2-.3.1-.5l-.4-2.6-2.1.8ZM58.5 228.3s1.2 1 1.6 2.2c.1.3-.1.7-.5.7h-2.3a.6.6 0 0 1-.6-.7c.1-.8.6-2.2 1.8-2.2Z",
    fill: "#05387D"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m56.5 225.7 1 3c0 .2.1.2.3.2l.6-.3c.1 0 .2 0 .2-.2l-.1-2.9-2 .2Z",
    fill: "#05387D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m66.8 198 6.5 27.1c0 .2 0 .5-.3.6-.4.3-1.1.7-1.8.8-.2.1-.5 0-.6-.3l-8-18.8-.3-.2-.9-.1c-.1 0-.3 0-.3.2-.6 1.3-3 8.5-2.2 18.2 0 .2-.1.4-.3.4l-2.2.2c-.2 0-.4 0-.4-.3-.6-3-5.2-23-1.3-32l12 4.2Z",
    fill: "#007ECC"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m73.6 228-.8.4-.8-.4-.6 2.3 6.4-.2-2.5-1-1.7-1.1Z",
    fill: "#05387D"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m74.6 175.7-5.9 6s-6.5-4.5-8-8.2c-1-2.9 1.3-9.9 8.4-5.6 3.5 2 5.5 7.8 5.5 7.8Z",
    fill: "#007ECC"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M68.6 181.2a14.9 14.9 0 0 1-5-3l-1.8-2a8 8 0 0 1-1-2.7c.3.9.7 1.7 1.2 2.4a14 14 0 0 0 4.1 3.8l2.5 1.5Z",
    fill: "#007ECC"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m69.3 172.1.5 7.2s-.7.2-1-.4",
    fill: "#05387D"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6 168.1c7.4 10.8-1.1 23.5.7 34.5.1.5-.6.7-1.2.7l-1.5.2-1.6.2c-2.8.6-5.8.6-8.6-.2l-2.7-.7c-.7-.1-1.2-.7-1.3-1.4 0-2.4-1.5-13.8-1.5-17.3.3-14.1 6.8-15.6 8.3-16.4.4-.2 2-.4 2.4-.4 3.1.1 4.9-2.3 7 .8Z",
    fill: "#B1E9ED"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7 169.8c-2.5-.6-4.3-1.5-5.8-1.2-.2 0 1-3.7 1.1-5l.1-2.3 5 1.1s-.5 1.7-.5 3v.3l-.4 2c.1.6 1.6 2.4.5 2Z",
    fill: "#05387D"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5 158.8c.3 1.8 3.4 6 5 6.4 2.4.7 5.1-.4 5.4-3 .3-2.5-3.8-7.8-5.5-8.2-2.5-.4-5.3 2.1-4.9 4.8Z",
    fill: "#05387D"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4 155.7c-5.2 1-3.6 3-3.6 3l.4.6c-.8-.5-1.7.5-1.3 1.3.3.6 1 2 .6 2.7-.1.3-.1.3-.5.3-1 0-2.3-.7-3-1.3a6.4 6.4 0 0 1-2.2-2.6c-.3-1-.2-2.2.7-3v-.7c.3-.8.7-1.4 1.3-1.8a8.2 8.2 0 0 1 5.4-1.6l2.4.3c.4 0 2-.3 1.8-1 0 0 .9 3.1-2 3.8ZM68.6 172H68.3h.1V171.6h-.2v.1l-.1.1v.2h.1v.1H68.6v-.1h.1V171.7H68.2V172.2h.2l.1-.2ZM69 174c0 .1 0 0 0 0V174.4h.2V174h-.4V174.4h.1l.1.1h.4v-.2l-.1-.1H69ZM69.6 175.9v-.2l-.1.1v-.1h-.2V176H69.7l.1-.1v-.2h-.1l-.2-.1h-.1v.3l.1.1h.1l.1-.1Z",
    fill: "#82CAF8"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M74 175.9c-1 1-2.7 2.8-3.2 4-1 2.5-1.6 3 .9 3.5 5.7 1.4 8.9.7 12.2-2a15 15 0 0 0 5.4-7.5l.4-1.3c4.3-13.7 0 0 0 0l-1.2-.3s-5.8 8.6-14.2 3.7l-.3-.1Z",
    fill: "#007ECC"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M53.2 169.7a186 186 0 0 0-.5 33.5c.1 1.3 2.1 1.3 2 0a186 186 0 0 1 .5-33.5c.2-1.3-1.8-1.3-2 0ZM59.5 167c-.2 12.5-.2 25 0 37.4 0 1.3 2 1.3 2 0-.2-12.5-.2-25 0-37.4 0-1.3-2-1.3-2 0ZM67.6 166.9l-.2 36.8c0 1.3 2 1.3 2 0l.2-36.8c0-1.3-2-1.3-2 0Z",
    fill: "#007ECC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M50.7 196.1c6 1.5 12.4 2 18.7 1.1 1.2-.1.7-2-.6-1.9a48 48 0 0 1-17.6-1c-1.3-.4-1.8 1.5-.5 1.8ZM49.5 183.6a61 61 0 0 0 22.3 3.2c1.3 0 1.3-2 0-2-7.3 0-14.9-.4-21.7-3.2-1.3-.4-1.8 1.5-.6 2ZM54.2 170.5c5.9.6 11.7.8 17.6 1.3 1.3 0 1.3-1.9 0-2l-17.6-1.2c-1.3-.2-1.3 1.8 0 2Z",
    fill: "#007ECC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M57 168.8a336.4 336.4 0 0 0-.4 36.8c0 .6 1 .6.9 0a337.8 337.8 0 0 1 .4-36.7c0-.6-.8-.6-.9 0ZM65.2 169.6v38.9c0 .6.8.6.8 0v-38.9c0-.6-.8-.6-.8 0Z",
    fill: "#007ECC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M50.2 193.3a98.8 98.8 0 0 0 19.5.6c.6 0 .6-1 0-.9a77.1 77.1 0 0 1-19.5-.6c-.5 0-.5.9 0 1ZM50.1 180.4a92.2 92.2 0 0 0 22.3 3.6c.6.1.6-.8 0-.9a123.7 123.7 0 0 1-22-3.6c-.6 0-.8.8-.3 1ZM54.1 172.2a114.7 114.7 0 0 1 18.7 1.6c.6.2.9-.7.3-.8a99.8 99.8 0 0 0-19-1.7c-.6 0-.6.9 0 .9Z",
    fill: "#007ECC"
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m70.9 178.5-3 7.7s-7.2-3-9.4-6.4c-1.7-2.6-.8-10 7-7.2 3.9 1.3 5.4 5.9 5.4 5.9Z",
    fill: "#B1E9ED"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2 172h1.3c.5 0 .9.3 1.3.4.8.4 1.6 1 2.2 1.6a9.6 9.6 0 0 1 2.3 3.2l.5 1.3-.8-1.1-.7-1-.4-.5-.2-.3-.3-.2-.4-.5-.5-.4c-.6-.6-1.2-1.1-2-1.5-.7-.5-1.4-.9-2.3-1ZM67.7 185.7a16.6 16.6 0 0 1-5.3-2.1c-.9-.5-1.7-1.1-2.3-1.8a8.6 8.6 0 0 1-1.6-2.4 12.1 12.1 0 0 0 4 3.9 26.1 26.1 0 0 0 5.2 2.4Z",
    fill: "#A4D7D8"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9 178.5c-1 1-2.7 2.7-3.3 4-1 2.5-1.5 3 1 3.5 5.7 1.4 10.6-.3 14-3a20 20 0 0 0 6.4-10c4.4-13.7 0 0 0 0l-1.2-.4s-8.3 10.9-16.6 6l-.3-.1Z",
    fill: "#05387D"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m90.5 170.4-1.4.7s-.2-.8-.5-.7c-.4 0-1 2.2-1 2.2l1.2.8 2.2-1c.2 0 .3-.2.3-.4l-.3-1.4c0-.2-.3-.4-.5-.2Z",
    fill: "#05387D"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M188.2 105.7H241l-20.3 22.8h-52.8l20.3-22.8Z",
    fill: "#74BAE8"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "m167.9 128.4 13.2-.3 13.2-.2 6.6-.2h6.6l3.3.1a125 125 0 0 1 10 .6v.1l-6.7.4-3.3.1-3.3.1H201l-6.6-.1-13.2-.2-13.2-.3v-.1Z",
    fill: "#86C7EE"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoFilters, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-filters.f9368d1d.svg";
export { ForwardRef as ReactComponent };